module.exports = __webpack_public_path__ + "static/img/lock.a551ef51.svg";